immutable = require 'seamless-immutable'
moment = require 'moment'
ObserveTeacherComponent = require '../components/ObserveTeacher'
React = require 'react'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'
{ doFlash } = require '../actions/flash'
{
	beginObservation,
	createObservationCycle,
	createTeacherObservation,
	createTeacherObservationEvent,
	endObservation,
	endObservationCycle,
	endTeacherObservation,
	pauseTeacherObservation,
	unpauseTeacherObservation
} = require '../actions/observations'
{
	beginObservation,
	endObservation
} = require '../actions/observations'
{
	OBSERVATION_PART_TYPE_IDS: {
		TEACHER
	}
} = require '../lib/commonIds'
mathLib = require '../lib/math'

class ObserveTeacherContainer extends Component
	@propTypes:
		createObservationCycle: PropTypes.func.isRequired
		createTeacherObservation: PropTypes.func.isRequired
		createTeacherObservationEvent: PropTypes.func.isRequired
		currentCycleNumber: PropTypes.number.isRequired
		endObservationCycle: PropTypes.func.isRequired
		endTeacherObservation: PropTypes.func.isRequired
		gradeLevelId: PropTypes.number.isRequired
		navigationWarningModal: PropTypes.node
		numberOfCycles: PropTypes.number.isRequired
		observation: PropTypes.object.isRequired
		pauseTeacherObservation: PropTypes.func.isRequired
		# startTimerAt is a moment duration, indicating how much of the cycle has already been observed, e.g. 2:34 out of 5:00.
		startTimerAt: PropTypes.object.isRequired
		# studentMinutes is a moment duration.
		teacherMinutes: PropTypes.object.isRequired
		teacher: PropTypes.object.isRequired
		toggleTeacherObservation: PropTypes.func.isRequired
		unpauseTeacherObservation: PropTypes.func.isRequired

	timerInterval: null

	constructor: (props) ->
		@state =
			data: immutable
				confirmingDone: false
				isTimerRunning: false
				isTimerUp: false
				timer: props.startTimerAt.asMilliseconds()

		@timerLastPausedAt = null

	componentWillMount: =>
		if @props.observation.observation_cycles
			if !!_.last(@props.observation.observation_cycles).ended_at
				@createObservationCycle()
		else
			@createObservationCycle()

	componentDidMount: =>
		now = moment.utc()
		@timerLastPausedAt = now
		@clockStartedAt = moment.utc(@timerLastPausedAt).subtract(@props.startTimerAt)
		@startTimer()

	componentWillUnmount: =>
		clearInterval(@timerInterval)
		@props.endObservationCycle()

	createObservationCycle: =>
		@props.createObservationCycle({
			started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
			observation_part_type_id: TEACHER,
			cycle_number: @props.currentCycleNumber,
			done: false
		})

	createTeacherObservationEvent: (teacherEventTypeId) =>
		observationEvent = {
			created_at: moment.utc().format('YYYY-MM-DD HH:mm:ss')
			teacher_event_type_id: teacherEventTypeId,
			cycle_number: @props.currentCycleNumber,
			time_on_clock: @getTimerAsString()
		}

		@props.createTeacherObservationEvent(observationEvent)

	getTimerAsString: =>
		if @state.data.timer
			return moment.duration(@state.data.timer).format('hh:mm:ss', { trim: false })
		else
			return '00:00:00'

	done: =>
		@props.endTeacherObservation()
		@props.endObservation()
		@props.toggleTeacherObservation()

	startTimer: =>
		@props.beginObservation()
		now = moment.utc()

		if @timerLastPausedAt
			referenceStartTime = moment.duration(@timerLastPausedAt.diff(@clockStartedAt))
		else
			referenceStartTime = moment.duration(0)

		@clockStartedAt = moment.utc(now).subtract(referenceStartTime)
		@cycleStartedAt = now

		@timerInterval = setInterval =>
			timer = moment.utc().diff(@clockStartedAt)
			@setState data: @state.data.set 'timer', timer
			localStorage.setItem('currentCycleElapsedSeconds', Math.round(timer / 1000))

			if moment.duration(timer).asMinutes() >= @props.teacherMinutes.asMinutes()
				@setState({
					data: @state.data.merge({
						confirmingDone: false
						isTimerUp: true
					})
				})

				@stopTimer()
		, 1000

		@setState({ data: @state.data.set('isTimerRunning', true) })

	stopTimer: =>
		clearInterval(@timerInterval)
		@setState({ data: @state.data.set('isTimerRunning', false) })
		@timerLastPausedAt = moment.utc()
		@props.endObservation()

	toggleTimer: =>
		{ data: { isTimerRunning } } = @state

		if isTimerRunning
			@createTeacherObservationEvent(14)
			@props.pauseTeacherObservation()
			@stopTimer()
		else
			@props.unpauseTeacherObservation()
			@createTeacherObservationEvent(15)
			@startTimer()

	handleUndo: =>
		@createTeacherObservationEvent(16)

	render: =>
		React.createElement(ObserveTeacherComponent, { \
			"askDone": ( => @setState({ data: @state.data.set('confirmingDone', true) }) ),  \
			"cancelDone": (=> @setState({ data: @state.data.set('confirmingDone', false) }) ),  \
			"confirmingDone": ( @state.data.confirmingDone ),  \
			"createTeacherObservation": ( @props.createTeacherObservation ),  \
			"createTeacherObservationEvent": ( @createTeacherObservationEvent ),  \
			"currentCycleNumber": ( @props.currentCycleNumber ),  \
			"done": ( if @state.data.isTimerUp then @props.toggleTeacherObservation else @done ),  \
			"endTeacherObservation": ( @props.endTeacherObservation ),  \
			"gradeLevelId": ( @props.gradeLevelId ),  \
			"handleUndo": ( @handleUndo ),  \
			"isTimerRunning": ( @state.data.isTimerRunning ),  \
			"isTimerUp": ( @state.data.isTimerUp ),  \
			"navigationWarningModal": ( @props.navigationWarningModal ),  \
			"numberOfCycles": ( @props.numberOfCycles ),  \
			"observation": ( @props.observation ),  \
			"teacher": ( @props.teacher ),  \
			"teacherMinutes": ( @props.teacherMinutes ),  \
			"timer": ( @getTimerAsString() ),  \
			"toggleTimer": ( @toggleTimer )
		})

mapStateToProps = (state) ->
	return {
		observation: state.observations.current
	}


mapDispatchToProps = {
	beginObservation,
	createObservationCycle,
	createTeacherObservation,
	createTeacherObservationEvent,
	doFlash,
	endObservation,
	endObservationCycle,
	endTeacherObservation,
	pauseTeacherObservation,
	unpauseTeacherObservation
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObserveTeacherContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/ObserveTeacher.cjsx